'use client';

import { useState } from 'react';

import { ArrowRight } from 'lucide-react';

import { cn } from '@kit/ui/utils';

import { SchedulingModal } from './google-calendar-button';

/**
 * Opens the demo scheduling modal in place, so server-rendered marketing
 * pages can offer the same booking flow as the landing page without
 * routing visitors back to '/'.
 */
export function ScheduleDemoButton({
  label,
  tone = 'light',
  className,
}: {
  label: string;
  tone?: 'light' | 'dark';
  className?: string;
}) {
  const [open, setOpen] = useState(false);

  return (
    <>
      <button
        type="button"
        onClick={() => setOpen(true)}
        className={cn(
          'group inline-flex h-[52px] cursor-pointer items-center gap-3 px-7 transition-colors md:h-[56px] md:px-8',
          tone === 'light'
            ? 'bg-white text-black hover:bg-[#ede8e2]'
            : 'bg-[#202020] text-white hover:bg-[#2b2b2b]',
          className,
        )}
      >
        <span className="font-roboto-mono text-[12px] font-bold uppercase md:text-[14px]">
          {label}
        </span>
        <ArrowRight className="h-4 w-4 transition-transform group-hover:translate-x-1 rtl:rotate-180 rtl:group-hover:-translate-x-1" />
      </button>
      <SchedulingModal open={open} onClose={() => setOpen(false)} />
    </>
  );
}
